<template>
  <metabase-dashboard :dashboard-id="DASHBOARD_ID" :title="t('Shipment Status Report')" />
</template>

<script>
import MetabaseDashboard from '@/components/metabase/MetabaseDashboard.vue';
import { useUtils as useI18nUtils } from '@core/libs/i18n';

const DASHBOARD_ID = 5;

export default {
  name: 'ShipmentStatusReport',

  components: {
    MetabaseDashboard
  },

  data() {
    return {
      DASHBOARD_ID
    };
  },

  setup() {
    const { t } = useI18nUtils();
    return { t };
  }
};
</script>
